<div class="w-full flex flex-col items-start gap-1 text-mainColor">
	<div class="text-sm font-semibold px-1">{{ rowName }}</div>

	<div
		class="flex items-center justify-between w-full h-12 rounded-xl border border-mainColorLight bg-white px-4 md:h-14 md:bg-mainColorHoverBg md:border-mainColorHoverBg"
	>
		<button
			(click)="operation($event, counter, options, -1, counter <= options[0])"
			class="flex h-full items-center justify-center px-2 focus:outline-none"
			[disabled]="counter <= options[0]"
		>
			<i
				[ngClass]="{
					'text-lightGray cursor-not-allowed': counter <= options[0],
					'text-mainColor cursor-pointer hover:scale-110 transition-transform': counter > options[0],
				}"
				class="fas fa-minus text-sm"
			></i>
		</button>

		<span class="font-bold text-sm text-mainColor select-none w-8 text-center">{{ counter }}</span>

		<button
			(click)="operation($event, counter, options, 1, counter >= options[options.length - 1])"
			class="flex h-full items-center justify-center px-2 focus:outline-none"
			[disabled]="counter >= options[options.length - 1]"
		>
			<i
				[ngClass]="{
					'text-lightGray cursor-not-allowed': counter >= options[options.length - 1],
					'text-mainColor cursor-pointer hover:scale-110 transition-transform':
						counter < options[options.length - 1],
				}"
				class="fas fa-plus text-sm"
			></i>
		</button>
	</div>
</div>

<ng-content></ng-content>
